export default "__VITE_ASSET__BlLImDrd__"